/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-02 17:27:05
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import React from 'react';
import { EPayMode, UNLIMITED_PACKAGE_NUMBER } from '@root/constant';
import { IPackagePrice } from '@root/types/package';
import { useTranslation } from 'react-i18next';
import Radio from '../Radio';
import './index.less';

const DefaultPackageCard = ({
  goodsName = '',
  checkedPriceId,
  goodsPriceList = [],
  onSelectPrice,
  payMode = EPayMode.PayPal,
  tab,
  onChangeTab,
  TAB_SINGLE,
  TAB_UNLIMITED,
}: {
  TAB_SINGLE: any;
  TAB_UNLIMITED: any;
  tab: any;
  goodsName?: string;
  checkedPriceId: string;
  goodsPriceList?: IPackagePrice[];
  payMode?: EPayMode;
  onSelectPrice: (v: IPackagePrice) => any;
  onChangeTab: (v: any) => any;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="default-package-card">
        <h1>{goodsName}</h1>
        <p className="desc">{t('apple_pay_plan_description')}</p>
        <ul>
          <li>
            <h4>{t('apple_pay_plan_detail_1')}</h4>
            <p>{t('apple_pay_plan_detail_2')}</p>
          </li>
          <li>
            <h4>{t('apple_pay_plan_detail_3')}</h4>
            <p>{t('apple_pay_plan_detail_4')}</p>
            <p className="detail-note">{t('apple_pay_plan_detail_4_note')}</p>
          </li>
          <li>
            <h4>{t('apple_pay_plan_detail_5')}</h4>
            <p>{t('apple_pay_plan_detail_6')}</p>
          </li>
          <li>
            <h4>{t('smart_service')}</h4>
            <p>{t('apple_pay_plan_detail_8')}</p>
          </li>
          <li>
            <h4>{t('monitoring_report')}</h4>
            <p>{t('apple_pay_plan_detail_9')}</p>
          </li>
        </ul>
        {/* Apple Pay 不支持的年订阅的代码 */}
        {/* {payMode === EPayMode.ApplePay && (
          <>
            {goodsPriceList
              ?.filter((i) => i.planUnit === 'month')
              .map((i) => {
                if (i.buyNum === UNLIMITED_PACKAGE_NUMBER) {
                  return (
                    <div
                      className="price"
                      key={i.goodsPriceId}
                      onClick={onSelectPrice(i)}
                    >
                      <div className="price-info">
                        <h2>
                          ${i.price || ''}
                          <span>{t('apple_pay_plan_per_month')},</span>
                          <span className="device">
                            {t('unlimited_devices')}
                          </span>
                        </h2>
                        <p>{t('unlimited_devices_tips')}</p>
                      </div>
                      <div className="price-radio">
                        <Radio checked={checkedPriceId === i.goodsPriceId} />
                      </div>
                    </div>
                  );
                }

                if (i.buyNum === 1) {
                  return (
                    <div
                      className="price"
                      key={i.goodsPriceId}
                      onClick={onSelectPrice(i)}
                    >
                      <div className="price-info">
                        <h2>
                          ${i.price || ''}
                          <span>{t('apple_pay_plan_per_month')},</span>
                          <span className="device">
                            {t('apple_pay_plan_per_camera')}
                          </span>
                        </h2>
                        <p>{t('apple_pay_plan_detail_7')}</p>
                      </div>
                      <div className="price-radio">
                        <Radio checked={checkedPriceId === i.goodsPriceId} />
                      </div>
                    </div>
                  );
                }

                return '';
              })}
            <p className="plan-tips">{t('apple_pay_plan_tips')}</p>
          </>
        )} */}
      </div>
      <div className="package-price">
        <ul className="tab">
          <li
            className={tab === TAB_SINGLE ? 'active' : ''}
            onClick={() => onChangeTab(TAB_SINGLE)}
          >
            {t('single')}
          </li>
          <li
            className={tab === TAB_UNLIMITED ? 'active' : ''}
            onClick={() => onChangeTab(TAB_UNLIMITED)}
          >
            {t('unlimited')}
          </li>
        </ul>
        <div className="package-price-list">
          {goodsPriceList
            .filter((item) =>
              tab === TAB_UNLIMITED
                ? item.buyNum === UNLIMITED_PACKAGE_NUMBER
                : item.buyNum === 1,
            )
            .map((item) => {
              return (
                <div
                  key={item.goodsPriceId}
                  className={
                    checkedPriceId === item.goodsPriceId
                      ? 'package-price-item selected'
                      : 'package-price-item'
                  }
                  onClick={onSelectPrice(item)}
                >
                  <h6>
                    {item.planUnit === 'year'
                      ? t('annual_plan')
                      : t('monthly_plan')}
                  </h6>
                  <div className="package-price-item-price">
                    <div className="package-price-item-price-item1">
                      {item.planUnit === 'year'
                        ? item.buyNum === 1
                          ? '$35.88'
                          : '$199.99'
                        : item.buyNum === 1
                        ? '$3.99'
                        : '$11.99'}
                    </div>
                    <div className="package-price-item-price-item2">
                      ${item.price || ''}
                    </div>
                  </div>
                  <p>
                    /{' '}
                    {item.buyNum === UNLIMITED_PACKAGE_NUMBER
                      ? t('unlimited_devices')
                      : t('cover_device', { count: item.buyNum })}
                  </p>
                  <div className="package-price-item-limit">{t('limited')}</div>
                </div>
              );
            })}
        </div>
        <p className="plan-tips">{t('apple_pay_plan_tips')}</p>
        {payMode !== EPayMode.ApplePay && (
          <p className="plan-tips">{t('price_settlement_tips')}</p>
        )}
      </div>
    </>
  );
};

export default DefaultPackageCard;
